import { render, staticRenderFns } from "./OrderBoxKan.vue?vue&type=template&id=3902738d&scoped=true"
import script from "./OrderBoxKan.vue?vue&type=script&lang=js"
export * from "./OrderBoxKan.vue?vue&type=script&lang=js"
import style0 from "./OrderBoxKan.vue?vue&type=style&index=0&id=3902738d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902738d",
  null
  
)

export default component.exports